import React, { useEffect, useState } from 'react';
import { Row, Col, Button, message, Space, Popconfirm } from 'antd';
import ListCard from 'Molecules/ListCard';
import HeadingChip from 'Molecules/HeadingChip';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getOutletGroups } from '../ducks/actions'
import { removeOutletGroup, bulkRemoveOutletGroups } from '../ducks/services'
import ActionButton from 'Molecules/ActionButton';
import Search from './components/Search'
import AllRoles from '../../../../routing/config/AllRoles';
import { allowed } from '../../../../routing/config/utils';
import { getListQueryItems } from 'Modules/Application/ducks/actions';
import { useTranslate } from 'Translate';

export default (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const outlets = useSelector((state) => state.outlet.outletGroups);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(25);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [searchVal, setSearchVal] = useState(null);
  const globalListQuery = useSelector((state) => state.global.listQueryItems);
  const i18n = useTranslate();
  const { t } = i18n;

  const colName = [
    {
      title: t("General.code"),
      dataIndex: 'code',
      key: 'code',
      className: 'enable-click',
      sorter: true
    },
    {
      title: t("General.desc"),
      dataIndex: 'desc',
      key: 'desc',
      className: 'enable-click',
      sorter: true
    },
    {
      title: '',
      dataIndex: 'action',
      key: 'action',
      align: 'center',
      render: (text, record) =>
        <ActionButton
          title="outlet_group"
          btnAction1={() => navigate(`/outlet-group/${record.id}`)}
          recordId={record.id}
          onRemove={allowed([AllRoles.OUTLET.OUTLETGROUP], 'delete') && onRemove}
          setLoading={props.setLoading}
          loading={props.loading}
        />
    }
  ]

  const addNew = () => navigate('/outlet-group/add');

  const btnList = [
    {
      title: t("Outlet.confirm_remove_selected_outlet_groups"),
      text: t("General.bulk_remove"),
      classes: 'red-btn text-white attendance-success',
      permit: true,
      action: () => onBulkRemove(),
    },
    {
      text: `+ ${t("Outlet.new_outlet_group")}`,
      action: () => addNew(),
    },
  ];

  useEffect(() => {
    if(!globalListQuery.outletGroupListQuery) {
      dispatch(getOutletGroups(1, limit, '', '', null, props.setLoading));
      dispatch(getListQueryItems('outletGroupListQuery', 1, limit, '', '', null))
    } else {
      const {page, limit, sortOrder, sortColKey, searchValue} = globalListQuery.outletGroupListQuery
      dispatch(getOutletGroups(page, limit, sortOrder, sortColKey, searchValue, props.setLoading));
      setPage(page);
      setLimit(limit);
      setSearchVal(searchValue);
    }
  }, []);

  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  const onRemove = async (id) => {
    props.setLoading(true);

    const payload = {
      location_group_id: id,
      status_event: 'remove'
    }

    await removeOutletGroup(payload).then(res => {
      props.setLoading(false);
      if(res.data.code === 200){
        message.success(t("Outlet.outlet_group_removed_success"));
        setTimeout(() => dispatch(getOutletGroups(page, limit, '', '', searchVal, props.setLoading)), 500);
        dispatch(getListQueryItems('outletGroupListQuery', page, limit, '', '', searchVal, props.setLoading))
      }
    }).catch(e => {
      props.setLoading(false);
      message.error(e.message ?? t("General.something_went_wrong"));
    })
  }

  const onBulkRemove = async () => {
    props.setLoading(true);

    const payload = {
      location_groups: JSON.stringify(selectedRowKeys)
    }

    await bulkRemoveOutletGroups(payload).then(res => {
      props.setLoading(false);
      if(res.data.code === 200){
        rowSelection.onChange([]);
        message.success(t("Outlet.outlet_groups_removed_success"));
        setPage(1);
        setSearchVal(null);
        setTimeout(() => dispatch(getOutletGroups(1, limit, '', '', null, props.setLoading)), 500);
        dispatch(getListQueryItems('outletGroupListQuery', 1, limit, '', '', null, props.setLoading))
      }
    }).catch(e => {
      props.setLoading(false);
      message.error(e.message ?? t("General.something_went_wrong"));
    })
  }

  const onTableChange = (pagination, filters, sorter) => {
    setPage(pagination.current);
    setLimit(pagination.pageSize);
    if (sorter.order) {
      dispatch(getOutletGroups(pagination.current, pagination.pageSize, sorter.order, sorter.columnKey, searchVal, props.setLoading));
      dispatch(getListQueryItems('outletGroupListQuery', pagination.current, pagination.pageSize, sorter.order, sorter.columnKey, searchVal, props.setLoading))
    } else {
      dispatch(getOutletGroups(pagination.current, pagination.pageSize, '', '', searchVal, props.setLoading));
      dispatch(getListQueryItems('outletGroupListQuery', pagination.current, pagination.pageSize, '', '', searchVal, props.setLoading))
    }
  }

  const onSearch = (search) => {
    setPage(1);
    if (search) {
      let searching = {};
      searching = {
        name: search.name,
        code: search.code
      };
      setSearchVal(searching);
      dispatch(getOutletGroups(1, limit, '', '', searching, props.setLoading));
      dispatch(getListQueryItems('outletGroupListQuery', 1, limit, '', '', searching, props.setLoading))
    } else {
      setSearchVal(null);
      dispatch(getOutletGroups(1, limit, '', '', null, props.setLoading));
      dispatch(getListQueryItems('outletGroupListQuery', 1, limit, '', '', null, props.setLoading))
    }
  };

  const onClickRow = (record) => {
    return {
      onClick: (e) => {
        if (e.target.closest(".enable-click"))
        navigate(`/outlet-group/${record.id}`)
      },
    };
  };

  return (
    <>
      <Row gutter={[10, 10]}>
        <Col span={24}>
          <HeadingChip title={t("Outlet.outlet_groups")} btnList={allowed([AllRoles.OUTLET.OUTLETGROUP], 'write') && btnList} btnHidden={selectedRowKeys.length <= 0} />
        </Col>
        <Col span={24} className="clickRow">
          <ListCard
            onRow={onClickRow}
            Search={Search}
            onSearch={onSearch}
            searchVal={globalListQuery.outletGroupListQuery?.searchValue}
            ListData={outlets?.list?.map(x => ({...x, key: x.id}))}
            ListCol={colName}
            rowSelection={rowSelection}
            onChange={onTableChange}
            pagination={{
              total: outlets?.total_count,
              current: page,
              pageSize: limit
            }}
          />
        </Col>
      </Row>
    </>
  )
}